(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-upsell"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cart-upsell')) {
    customElements.define(
      'cart-upsell',
      class CartUpsell extends HTMLElement {
        connectedCallback() {
          this.form = this.querySelector('form');
          this.submitButton = this.querySelector('[type="submit"]');
          this.dismissButton = this.querySelector('.cart-upsell__dismiss');
          this.errorMessage = this.querySelector('.cart-upsell__error');
          this.cart = document.querySelector('cart-drawer');
          this.storageKey = `feenies-cart-upsell-dismissed-${this.dataset.offerType}`;

          if (sessionStorage.getItem(this.storageKey) === 'true') {
            this.hidden = true;
            return;
          }

          this.form?.addEventListener('submit', this.onSubmit.bind(this));
          this.dismissButton?.addEventListener('click', this.onDismiss.bind(this));
        }

        onDismiss() {
          sessionStorage.setItem(this.storageKey, 'true');
          this.hidden = true;
        }

        async onSubmit(event) {
          event.preventDefault();
          if (!this.form || !this.submitButton || this.submitButton.disabled) return;

          this.setLoading(true);
          this.showError(false);

          const config = fetchConfig('javascript');
          config.headers['X-Requested-With'] = 'XMLHttpRequest';
          delete config.headers['Content-Type'];

          const formData = new FormData(this.form);
          if (this.cart) {
            formData.append(
              'sections',
              this.cart.getSectionsToRender().map((section) => section.id)
            );
            formData.append('sections_url', window.location.pathname);
            this.cart.setActiveElement(this.submitButton);
          }
          config.body = formData;

          try {
            const response = await fetch(window.routes.cart_add_url, config).then((result) => result.json());

            if (response.status) throw new Error(response.description || response.message);

            if (this.cart) {
              this.cart.renderContents(response);
            } else {
              window.location = window.routes.cart_url;
            }
          } catch (error) {
            console.error(error);
            this.showError(true);
            this.setLoading(false);
          }
        }

        setLoading(isLoading) {
          this.submitButton.disabled = isLoading;
          this.submitButton.classList.toggle('loading', isLoading);
          this.querySelector('.loading__spinner')?.classList.toggle('hidden', !isLoading);
        }

        showError(shouldShow) {
          this.errorMessage.hidden = !shouldShow;
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
